export const FORM_VALIDATION_ERROR_MESSAGE = "Please fix the highlighted errors before submitting.";
